import './TabsCarouselComponentListing.css';
import React, { useEffect, useState } from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { canUseDOM, get, getDictionaryItem } from '../../utils';
import Switch from './components/Switch';
import { commonStyles as EventsCommonStyles } from '../15_Events/Events';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import RouterLink from '../atoms/RouterLink';
import EventBlock from '../15_Events/components/EventBlock';
import OfferAndDeal from '../102_ListingOffersAndDeals/components/OfferAndDeal';
import { useLocation } from 'react-router-dom';
import { qsToObject } from '../../utils/querystring';
import { TYPE } from '../../utils/constants';
import { convertToAnalyticObject } from '../../utils/analytics';
import { isNotNil } from '../../utils/IsNil';
import getListing from '../../utils/getListing';
import useProfile from '../../utils/hooks/useProfile';
export const TabsCarouselComponentListing = _ref => {
  let {
    fields,
    params
  } = _ref;
  const location = useLocation();
  const sitecoreContext = useSitecoreContext();
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const algoliaSettings = {
    key: get(sitecoreContext, 'configuration.algolia.algoliaApiKey'),
    id: get(sitecoreContext, 'configuration.algolia.algoliaApplicationId'),
    fullTextSearchIndex: get(sitecoreContext, 'configuration.algolia.fullTextSearchIndex')
  };
  const userProfile = useProfile();
  const [typesTabs, setTypesTabs] = React.useState('');
  const [mappedTypes, setMappedTypes] = React.useState([]);
  const [items, setItems] = useState([]);
  const BackgroundColorHex = get(params, 'BackgroundColorHex');
  const carouselBackgroundColor = BackgroundColorHex ? BackgroundColorHex : "transparent";
  const datasourceItems = get(fields, 'data.datasource.items', {});
  const datasourceTitle = get(fields, 'data.datasource.title.jss');
  const queryParams = qsToObject(location.search);
  const queriesType = canUseDOM && TYPE && queryParams[TYPE] ? queryParams[TYPE].replaceAll("+", " ") : null;
  const messageSearchResultEmpty = get(fields, 'data.contextItem.messageSearchResultEmpty.value', '');
  const socialSharing = get(fields, 'data.socialSharing');
  const countryItems = get(fields, 'data.countries.countryValues') || [];
  const dictionary = get(fields, 'data.dictionary');
  const bookNowText = getDictionaryItem(dictionary, 'bookNow') || '';
  const expiresSoonText = getDictionaryItem(dictionary, 'expiresSoon') || '';
  const termsAndConditionsText = getDictionaryItem(dictionary, 'termsAndConditions') || '';
  const fromText = getDictionaryItem(dictionary, 'from') || '';
  const offText = getDictionaryItem(dictionary, 'off') || '';
  const moreInfoText = getDictionaryItem(dictionary, 'moreInfo') || '';
  const ratingTextStars = getDictionaryItem(dictionary, 'stars') || '';
  const curatorPick = getDictionaryItem(dictionary, 'Curatorspick') || '';
  const item = get(fields, "data.datasource.items")[mappedTypes[queriesType]];
  const hitsPerPage = get(item, 'count.jss.value') || 10;
  const ctaLabel = get(item, 'ctaLabel.jss.value');
  const ctaLink = get(item, 'ctaLink.jss.value.href');
  const algoliaIndexes = get(params, 'SearchIndex');
  let eventsAnalytics = get(item, 'data.eventsAnalytics') || [];
  const typeValue = get(item, 'contentType.types.template.targetItem.value');
  const filterValues = get(item, 'filters.values') && get(item, 'filters.values').length ? get(item, 'filters.values')[0] : null;
  const fieldNameItem = filterValues ? get(filterValues, 'fieldNameItem.item.fieldName.value') : null;
  const tagsToDisplayValues = filterValues ? get(filterValues, 'tagsToDisplay.values') : null;
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  const algoliaRequest = () => {
    let types = `type:${typeValue}`;
    const optionsValues = () => tagsToDisplayValues.map(tag => `${fieldNameItem}:${tag.title.value}`);
    const facetFilters = isNotNil(fieldNameItem) && isNotNil(tagsToDisplayValues) ? [types, ...optionsValues()] : [types];
    const itemFilters = {
      facetFilters,
      hitsPerPage: hitsPerPage > 10 ? 10 : hitsPerPage
    };
    getListing(algoliaIndexes, itemFilters, algoliaSettings).then(response => {
      setItems(response.hits);
    }).catch(error => {
      console.log("error", error);
    });
  };
  React.useEffect(() => {
    const types = datasourceItems.reduce((acc, item, index) => {
      const key = get(item, 'contentType.types.template.targetItem.value', []);
      acc[key] = index;
      return acc;
    }, {});
    setMappedTypes(types);
    setTypesTabs(datasourceItems.map(item => get(item, 'contentType.types.template.targetItem.value', [])));
  }, []);
  useEffect(() => {
    if (isNotNil(typeValue)) {
      algoliaRequest();
    }
  }, [location.search, typeValue]);
  if (!fields) {
    console.warn('TabCarouselComponentListing component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [TabCarouselComponentListing component is empty: please provide data source]");
    }
    return null;
  }
  const renderItems = () => {
    if (!items.length) {
      return [];
    }
    return items.map((event, index) => {
      if (event.type.some(v => ~v.indexOf('Event'))) {
        return /*#__PURE__*/React.createElement(EventBlock, {
          key: index,
          userProfile: userProfile,
          event: event,
          curatorsCopy: curatorPick,
          hostLink: '',
          lang: 'en',
          themeValues: [],
          analytics: {
            eventsAnalytics,
            params
          }
        });
      }
      if (event.type.some(v => ~v.indexOf('Offer And Deal'))) {
        return /*#__PURE__*/React.createElement(OfferAndDeal, {
          key: index,
          userProfile: userProfile,
          deal: event,
          eventsAnalytics: eventsAnalytics,
          gridMode: false,
          params: params,
          rtl: rtl,
          fromText: fromText,
          offText: offText,
          moreInfoText: moreInfoText,
          expiresSoonText: expiresSoonText,
          bookNowText: bookNowText,
          termsAndConditionsText: termsAndConditionsText,
          socialSharing: socialSharing,
          ratingTextStars: ratingTextStars,
          countryItems: countryItems
        });
      }
    });
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    style: {
      background: carouselBackgroundColor
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-11"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h3",
    field: datasourceTitle
  }), /*#__PURE__*/React.createElement(CarouselProvider, null, _ref2 => {
    let {
      renderCarousel,
      renderPreviousButton,
      renderNextButton,
      renderDots,
      state,
      moveToSlide
    } = _ref2;
    return /*#__PURE__*/React.createElement(React.Fragment, null, typesTabs.length ? /*#__PURE__*/React.createElement(Switch, {
      tagsToDisplay: typesTabs,
      fields: fields,
      rtl: rtl,
      moveToSlide: moveToSlide
    }) : null, Object.keys(mappedTypes).length ? /*#__PURE__*/React.createElement(StyledWrapper, {
      rtl: rtl
    }, /*#__PURE__*/React.createElement("div", {
      className: `tab-carousel__wrapper ${rtl && get(state, 'slidesToShow') >= get(state, 'totalItems') ? 'item-rtl-carousal-fix' : ''}`
    }, /*#__PURE__*/React.createElement("div", {
      className: "top-buttons"
    }, /*#__PURE__*/React.createElement("div", {
      className: "pagination__btn"
    }, /*#__PURE__*/React.createElement("div", {
      className: `btn-group--right ${rtl ? 'btn-group-rtl' : ''}`
    }, renderPreviousButton(() => {
      tealiumClickFunc(tealiumMergeClickData({}, params));
    }), renderNextButton(() => {
      tealiumClickFunc(tealiumMergeClickData({}, params));
    })))), items && items.length ? /*#__PURE__*/React.createElement("div", {
      className: "module-group no-padding-top"
    }, /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-lg-12",
      style: {
        display: 'block'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "card-container__inner"
    }, renderCarousel(renderItems(), {
      responsive: {
        large: {
          breakpoint: {
            max: 10000,
            min: 1601
          },
          items: 4
        },
        desktop: {
          breakpoint: {
            max: 1600,
            min: 992
          },
          items: 3
        },
        tablet: {
          breakpoint: {
            max: 991,
            min: 768
          },
          items: 2
        },
        mobile: {
          breakpoint: {
            max: 767,
            min: 0
          },
          items: 1
        }
      },
      containerClass: "carouselContainer"
    }, () => tealiumClickFunc(tealiumMergeClickData({}, params))))))) : null, !items.length && /*#__PURE__*/React.createElement("h4", {
      className: "message-search-result-empty",
      dangerouslySetInnerHTML: {
        __html: messageSearchResultEmpty
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "module-group no-padding-bottom"
    }, /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "footer-buttons"
    }, /*#__PURE__*/React.createElement("div", {
      className: "module-group read-more__row"
    }, ctaLabel && ctaLink && /*#__PURE__*/React.createElement(RouterLink, {
      onClick: () => {
        tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['discoverMoreAnalytics'], params), ctaLabel);
      },
      className: "btn btn-primary",
      title: ctaLabel,
      href: ctaLink,
      linktype: "external",
      openInSameTab: true
    }, /*#__PURE__*/React.createElement("span", {
      className: "btn-tertiary__text"
    }, ctaLabel))), items && items.length ? /*#__PURE__*/React.createElement("div", {
      className: "pagination-dot"
    }, renderDots(() => tealiumClickFunc(tealiumMergeClickData({}, params)))) : null))))) : null);
  })));
};
const StyledWrapper = _ref3 => {
  let {
    children,
    rtl,
    style
  } = _ref3;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    className: ` ${commonStyles} ${EventsCommonStyles} ${rtl ? rtlStyles : ltrStyles}`,
    style: style
  }, children);
};
const commonStyles = "c11wp7dl";
const ltrStyles = "l1imdw8e";
const rtlStyles = "r1q8q42q";
export default TabsCarouselComponentListing;